<template>
    <span class="uik-nav-section-title__wrapper">
        <slot></slot>
    </span>
</template>

<script>
export default {
    name: "UikNavSectionTitle"
}
</script>

<style lang="scss">
.uik-nav-section-title__wrapper {
  text-transform: uppercase;
  font-weight: 500;
  font-size: 0.75rem;
  color: $textSecondary;
  line-height: 1.5;
  display: block;
  padding: 10px 30px;
}
</style>
